import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { IUniversalSelectOption } from '@feathr/components';
import { UniversalSelect } from '@feathr/components';

import * as styles from './InteractionSelect.css';

interface IProps {
  onChange: (id?: 'form_submission' | 'form_view') => void;
}

interface IOption extends IUniversalSelectOption {
  id: 'form_submission' | 'form_view';
}

function InteractionSelect({ onChange }: IProps): JSX.Element {
  const [selected, setSelected] = useState<string | undefined>();
  const { t } = useTranslation();
  const options: IOption[] = [
    { id: 'form_submission', name: t('Submission') },
    { id: 'form_view', name: t('View') },
  ];

  function handleSelectSingle({ id }: IOption): void {
    onChange(id);
    setSelected(id);
  }

  function handleClear(): void {
    onChange(undefined);
    setSelected(undefined);
  }

  const selectedOption = options.find((option) => option.id === selected);

  return (
    <UniversalSelect<IOption>
      isClearable={true}
      name={'interaction'}
      onClear={handleClear}
      onSelectSingle={handleSelectSingle}
      options={options}
      placeholder={t('Filter by')}
      value={selectedOption}
      wrapperClassName={styles.root}
    />
  );
}

export default InteractionSelect;
